module.exports = __webpack_public_path__ + "img/img65.873ef780.svg";